<template>
  <div class="stockCont" style="width:800px;">
    <h1>商品入库</h1>
    <el-form ref="formAdd" :model="formAdd" :rules="rulesAdd" label-width="140px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="入库商品类型" prop="serviceType">
            <el-select v-model="formAdd.serviceType" style="width:240px">
              <el-option label="整套服务商品" value="2" v-if="$route.params.id == 2"></el-option>
              <el-option label="零售商品" value="10" v-if="$route.params.id == 10"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品入库原因" prop="inRemaeks">
            <el-input type="textarea" v-model="formAdd.inRemaeks" style="height:110px;width: 95%;" placeholder="请输入简介,30字以内" resize="none"></el-input>
          </el-form-item>
          <el-form-item label="选择入库商品" required>
            <template>
              <el-button class="darkBtn" style="width:155px" @click="chooseRelation">选择入库商品</el-button>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formAdd.storeChildSe.length > 0">
        <el-form-item prop="storeChildSe">
          <el-table :data="formAdd.storeChildSe" border class="myRelayionTable" :cell-style="{height:'40px'}" style="width: 100%" :header-cell-style="{background:'#EFF1F5',height:'40px'}">
            <el-table-column align="center" prop="serviceName" label="商品名称"></el-table-column>
            <el-table-column align="center" prop="serviceTimes" :label="$route.params.id == 2 ? '整套服务商品入库套数':'零售商品入库件数' ">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.serviceTimes" controls-position="right" :min="1" :max="10000" size="small"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>     
      </el-row>
      <el-row>
        <el-col :span="22">
          <div class="btnOptions">
            <el-button class="darkBtn" @click="closeTab">取消</el-button>
            <el-button class="redBtn" @click="onlySave()">保存</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog :title="$route.params.id == 2 ? '选择整套服务入库商品':'选择零售入库商品'" :visible.sync="dialogTableVisible" :center="true" width="760px">
      <chooseRelation @rowClicks="rowClickMethod" :dialogTableVisible="dialogTableVisible" :serverLins="formAdd.serviceType" />
    </el-dialog>
  </div>
</template>
<script>
import chooseRelation from "./chooseRelation";
import {commodityWarehousing} from "@/api";
export default {
  components: {
    chooseRelation
  },
  data() {
    return {
      formAdd:{
        serviceType:this.$route.params.id == 2 ? '2' : '10',
        inRemaeks:'',
        storeChildSe:[]
      },
      rulesAdd:{
        inRemaeks: [
          // {required: true,message: "请输入简介",trigger: "blur"},
          {min: 0,max: 50, message: "长度在 0 到 50 个字符",trigger: "blur"}
        ]
      },
      dialogTableVisible:false
    };
  },
  methods: {
    onlySave() {      // 保存
      this.$refs.formAdd.validate(valid => {
        if (valid) {
          if(this.formAdd.storeChildSe.length <= 0){
            this.$message({
              message:'请选择入库商品',
              type:"warning"
            })
          }else{
            let postData={}
              postData.serviceType = this.formAdd.serviceType
              postData.inRemaeks = this.formAdd.inRemaeks
              postData.storeServices = []
              this.formAdd.storeChildSe.forEach((val, index, arr) => {
                let obj = {}
                obj.id = val.storeServiceId,
                obj.availableStock = val.serviceTimes,
                obj.creatorId = this.$store.state.userInfo.staffId,
                obj.createName = this.$store.state.userInfo.staffName,
                postData.storeServices.push(obj)
              });
            commodityWarehousing(postData).then(res => {
              if(res.code == 1){
                this.$message({
                  message:res.msg,
                  type:'success'
                });
                this.closeTab();
              }else{
                this.$message({
                  message:res.msg,
                  type:'warning'
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    rowClickMethod(val) {// 选择关联商品后的回调
      val.forEach(item =>{
        item.serviceTimes =1;
      })
      this.formAdd.storeChildSe = val;
      this.dialogTableVisible = false;
    },
    chooseRelation() {// 选择套盒
      this.dialogTableVisible = true;
    },
    closeTab() { // 取消
      this.$store.commit("delete_tabs", this.$route.path);
      this.$router.push('/businessManagementCenter/stock');
    },
  }
};
</script>
<style lang="less" scoped>
.stockCont {
  padding: 25px 0;margin:0 auto;
  h1{display:block; text-align:center;font-size: 18px;font-weight: bolder;margin:50px 0 80px;}
  .btnOptions {
    margin: 50px 0 0 150px;
    .onSale {
      background: #2ecfa7;
      color: #fff;
    }
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
}
</style>
<style lang="less">
.stockCont {
  .el-input-number .el-input__inner{
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/substock.vue